import React, { Component } from 'react';
import animations from './animations';
import globals from '../../globals';

class FancySelect extends Component {

    componentDidMount() {
        document.addEventListener('click', (event) => {
            if (this.inner) {
                let isClickInside = this.inner.contains(event.target);
                if (!isClickInside) {
                    this.initialise();
                    animations.toggleClose();
                }
            }
        });
    }

    initialise() {
        animations.initialise(this.container, this.label, this.dropdown, this.bg);
    }

    render() {
        const handleShowDropDown = (event) => {
            event.preventDefault();
            this.initialise();
            if (this.dropdown && this.dropdown.offsetHeight > 1) {
                animations.toggleClose();
            } else {
                animations.toggleOpen();
            }
        };

        const handleSelection = (event) => {
            event.preventDefault();
            this.initialise();

            let value = event.currentTarget.innerHTML;

            this.props.setValue(globals.alphaNumeric(value));
            this.label.innerHTML = value;
            animations.toggleClose();
        };

        const List = () => {
            if (this.props.list) {
                return this.props.list.map((value, key) => {
                    return (
                        <a href="#" key={key} onClick={handleSelection.bind(this)} dangerouslySetInnerHTML={{__html: value}} />
                    );
                });
            }
        };

        return (
            <div className={'fancy-select ' + (this.props.theme ? this.props.theme : '')} ref={el => this.container = el}>
                <div className="title input-label-styled">{this.props.title}</div>
                <div className="inner" ref={el => this.inner = el}>
                    <div className="bg" ref={el => this.bg = el} />
                    <a
                        href="#"
                        className="label"
                        ref={el => this.label = el}
                        onClick={handleShowDropDown.bind(this)}
                    >
                        Select Option: 
                    </a>
                    <div 
                        className="dropdown" 
                        ref={el => this.dropdown = el}
                    >
                        {List()}
                    </div>
                </div>
            </div>
        );
    }

}

export default FancySelect;


// WEBPACK FOOTER //
// ./resources/assets/js/elements/FancySelect/FancySelect.js